import classNames from 'classnames';
import React from 'react';
import Avatar from '../components/Avatar';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import * as styles from './PresenceAvatar.module.scss';

const NUM_CURSOR_COLORS = 6;

export type PresenceAvatarStatus = 'editing' | 'reading' | 'inactive';

const PRESENCE_AVATAR_USER_FRAGMENT = gql(`
  fragment PresenceAvatar_user on User {
    id
    ...Avatar_user
  }
`);

interface PresenceAvatarProps {
  user: DocumentType<typeof PRESENCE_AVATAR_USER_FRAGMENT>;
  index: number;
  status: PresenceAvatarStatus;
}

const PresenceAvatar = ({ user, index, status }: PresenceAvatarProps) => {
  return (
    <div
      key={user.id}
      className={classNames(
        styles.container,
        styles[`cursorColor${(index % NUM_CURSOR_COLORS) + 1}`],
        { [styles.editing]: status === 'editing' },
      )}
    >
      <Avatar
        user={user}
        muted={status === 'inactive'}
        size={status === 'editing' ? 24 : 28}
      />
    </div>
  );
};

export default PresenceAvatar;
